var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.58,5.5a2,2,0,0,1,.15,4h-.15a2,2,0,1,1,0-4Zm0-2.84a5,5,0,0,0-4.19,7.57l4.24,6.12,4.12-6.09a5,5,0,0,0,.77-2.37V7.61A5,5,0,0,0,15.58,2.66Zm4.9,10.1L18,16.44,25.8,22l2.85-3.41Zm-7.69,3-4.24.6L19,23.82l4.92-.7-7-5L15.65,19.9ZM6.33,17.24,3.22,21l11.17,8,3.11-3.73ZM15.58.66a6.94,6.94,0,0,1,6,10.43l10,7.13-5.51,6.61-6.4.91-4.92,5.91L.31,21.34l5.51-6.61,5.69-.81L9.72,11.34A6.89,6.89,0,0,1,8.65,7.92V7.61A7,7,0,0,1,15.58.66Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.bc6be8e1.svg";
export { ForwardRef as ReactComponent };